const WhatsAppIconColor = ({ width, height }) => {
  return (
    <svg
      width={width ? width : "48"}
      height={height ? height : "48"}
      viewBox="6 0 36 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_172_371)">
        <path
          d="M17.7998 33.5798L18.2193 33.8283C19.981 34.8739 22.0009 35.4269 24.0608 35.4279H24.0652C30.3912 35.4279 35.5396 30.2808 35.5422 23.9543C35.5433 20.8885 34.3507 18.0057 32.1837 15.8371C30.0167 13.6685 27.1354 12.4737 24.0696 12.4724C17.7388 12.4724 12.5903 17.619 12.588 23.945C12.5871 26.1128 13.1937 28.2242 14.3425 30.0511L14.6156 30.4851L13.4559 34.7188L17.7998 33.5798ZM10.1406 37.9984L12.0997 30.8453C10.8914 28.752 10.2557 26.3771 10.2565 23.9442C10.2596 16.3329 16.4537 10.1406 24.0652 10.1406C27.7589 10.1424 31.2258 11.5799 33.8332 14.1891C36.4399 16.7984 37.8753 20.2666 37.874 23.9553C37.8706 31.5661 31.6755 37.7594 24.0652 37.7594C24.0647 37.7594 24.0658 37.7594 24.0652 37.7594H24.0593C21.7485 37.7585 19.4778 37.1788 17.4607 36.0789L10.1406 37.9984Z"
          fill="#B3B3B3"
        />
      </g>
      <path
        d="M10 37.8578L11.9591 30.7047C10.7508 28.6114 10.1151 26.2365 10.1159 23.8036C10.119 16.1922 16.313 10 23.9246 10C27.6183 10.0018 31.0852 11.4392 33.6926 14.0485C36.2993 16.6578 37.7347 20.1259 37.7334 23.8147C37.73 31.4255 31.5349 37.6188 23.9246 37.6188C23.9241 37.6188 23.9252 37.6188 23.9246 37.6188H23.9187C21.6079 37.6178 19.3371 37.0382 17.3201 35.9382L10 37.8578Z"
        fill="white"
      />
      <path
        d="M23.9309 12.3359C17.6 12.3359 12.4515 17.4825 12.4492 23.8085C12.4483 25.9763 13.055 28.0877 14.2038 29.9146L14.4769 30.3486L13.3171 34.5823L17.6611 33.4433L18.0805 33.6919C19.8423 34.7375 21.8621 35.2904 23.9221 35.2914H23.9264C30.2524 35.2914 35.4009 30.1443 35.4035 23.8178C35.4046 20.7521 34.212 17.8692 32.045 15.7006C29.878 13.532 26.9966 12.3372 23.9309 12.3359Z"
        fill="url(#paint0_linear_172_371)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4756 18.0338C20.2169 17.4594 19.9449 17.4478 19.6992 17.4377C19.498 17.4292 19.2678 17.4297 19.0379 17.4297C18.8077 17.4297 18.434 17.5161 18.1179 17.8613C17.8016 18.2066 16.9102 19.0412 16.9102 20.7388C16.9102 22.4364 18.1466 24.0766 18.3189 24.307C18.4914 24.5372 20.7057 28.1321 24.2129 29.515C27.1274 30.6643 27.7204 30.4357 28.3533 30.3783C28.9859 30.3208 30.3946 29.5437 30.6819 28.7381C30.9695 27.9324 30.9695 27.2422 30.8834 27.0979C30.797 26.9538 30.5671 26.8677 30.2218 26.6952C29.8768 26.5227 28.1805 25.6878 27.8642 25.5727C27.5479 25.4577 27.318 25.4002 27.0878 25.7455C26.8579 26.0908 26.1971 26.8677 25.9956 27.0979C25.7944 27.3283 25.5932 27.357 25.248 27.1845C24.903 27.0115 23.7916 26.6476 22.4734 25.4721C21.4477 24.5576 20.7554 23.4282 20.5539 23.083C20.3527 22.7377 20.5325 22.551 20.7055 22.379C20.8604 22.2243 21.0505 21.9761 21.2232 21.7746C21.3952 21.5731 21.4529 21.4293 21.5677 21.1994C21.6828 20.969 21.6254 20.7675 21.539 20.595C21.4529 20.4225 20.7823 18.7161 20.4756 18.0338"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_172_371"
          x="0.432486"
          y="0.432486"
          width="47.1507"
          height="47.2757"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.85407"
            result="effect1_foregroundBlur_172_371"
          />
        </filter>
        <linearGradient
          id="paint0_linear_172_371"
          x1="23.6927"
          y1="13.7135"
          x2="23.8091"
          y2="33.3303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#57D163" />
          <stop offset="1" stopColor="#23B33A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WhatsAppIconColor;
